import { useQuery } from '@tanstack/react-query';
import { portalGet } from '@/lib/portal/customerClient';
import { usePortalAuthStore } from '@/stores/portalAuth.store';

export interface PortalAccountAddress {
  id: string;
  label: string | null;
  street: string;
  street2?: string | null;
  city: string;
  state: string;
  zip: string;
}

export interface PortalAccountPaymentMethod {
  type: string;
  brand: string | null;
  last4: string | null;
  expMonth: number | null;
  expYear: number | null;
  label: string | null;
}

export interface PortalAccount {
  contact: { firstName: string; lastName: string; email: string | null; phone: string | null };
  customerSince: string | null;
  serviceAddresses: PortalAccountAddress[];
  paymentMethod: PortalAccountPaymentMethod | null;
}

/** The signed-in contact's account (profile + addresses + default card). */
export function usePortalAccount() {
  const token = usePortalAuthStore((s) => s.token);
  return useQuery({
    queryKey: ['portal', 'account', token],
    queryFn: () => portalGet<PortalAccount>('/api/portal/account'),
    enabled: Boolean(token),
    retry: false,
  });
}
